import clsx, { type ClassValue } from 'clsx';

import { twMerge } from '@zep/utils';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
